export default __webpack_public_path__ + "static/media/badge.e61af1d8.svg";